import { render, staticRenderFns } from "./EditHome.vue?vue&type=template&id=624b743d&"
import script from "./EditHome.vue?vue&type=script&lang=js&"
export * from "./EditHome.vue?vue&type=script&lang=js&"
import style0 from "./EditHome.vue?vue&type=style&index=0&id=624b743d&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports